export default () => ({})

export const repo = (props, orgName, repoName) => ({
  orgName, repoName
})



// WEBPACK FOOTER //
// ./src/router/stateHandlers.js